import { useCallback } from "react";

import { Box, Typography } from "@mui/material";
import { useQueryClient } from "react-query";
import offIcon from "src/assets/images/device-type-icons/light-off.svg";
import onIcon from "src/assets/images/device-type-icons/light.svg";

import api from "../../../../../../../../../api/api";
import { useTranslatedStrings } from "../../../../../../../../../hooks/translate";
import DeviceWidgetTitle from "../../device-title";

interface Props {
  device: Device;
}
export default function LightDevice(props: Props) {
  const queryClient = useQueryClient();

  const { device } = props;
  const isOn = device.powerState == "ON";
  const percentage = device.percentage;

  const strings = useTranslatedStrings();
  const deviceId = device._id ?? "";
  const backgroundColor = isOn ? "white" : "rgb(51, 51, 51)";

  const onclick = useCallback(async () => {
    const response = await api.apiV4DirectiveDeviceDeviceIdPut(deviceId, {
      source: "web",
      directive: { field: "powerState", value: isOn ? "OFF" : "ON" },
    });
    if (response.status == 200) {
      queryClient.invalidateQueries(["devices", `${deviceId}`]);
    }
  }, [deviceId, isOn, queryClient]);

  return (
    <Box
      sx={{
        padding: "3px",
        backgroundColor,
        height: "100%",
        borderRadius: "5px",
        display: "flex",
        flexDirection: "column",
      }}
      onClick={onclick}
    >
      <DeviceWidgetTitle device={device} />
      <Box sx={{ display: "flex", justifyContent: "space-between", flex: 2 }}>
        <Box
          sx={{
            paddingLeft: "10px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <img src={isOn ? onIcon : offIcon} width={"60"} />
        </Box>
        <Box sx={{ flex: 1 }} />
        <Box sx={{ textAlign: "end" }}>
          <Typography
            variant="h2"
            sx={{ color: "grey", margin: "10px 15px 0 0" }}
          >
            {isOn ? strings.on : strings.off}
          </Typography>
          <Typography variant="h5" sx={{ color: "grey", marginRight: "15px" }}>
            {percentage}%
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
